// removed by extract-text-webpack-plugin
module.exports = {"notAuthorizedContainer":"notAuthorizedContainer___1QfCr","notAuthorizedMessage":"notAuthorizedMessage___AX_YL"};


//////////////////
// WEBPACK FOOTER
// ./src/components/NotAuthorized/NotAuthorized.module.less
// module id = 3777
// module chunks = 33